<div class="row" id="main-content">
  <div class="col-xl-12 col-sm-12 h-100">
    <div class="row h-100">
      <div class="col-sm-12 menu">
        <mat-form-field appearance="fill" style="width: 12%">
          <mat-label>From Date</mat-label>
          <input matInput [formControl]="selectedFromDate" [matDatepicker]="fromPicker" (dateChange)="fromDateFilterChanged($event.value)">
          <mat-datepicker-toggle matSuffix [for]="fromPicker">
          </mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 12%">
          <mat-label>To Date</mat-label>
          <input matInput [formControl]="selectedToDate" [matDatepicker]="toPicker" (dateChange)="toDateFilterChanged($event.value)">
          <mat-datepicker-toggle matSuffix [for]="toPicker">
          </mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 12%">
          <mat-label>Depot</mat-label>
          <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)">
            <mat-option value="">None</mat-option>
            @if (!depotList || depotList.length != 1) {
              <mat-option value="00000000-0000-0000-0000-000000000000">All</mat-option>
            }
            @for (depot of depotList; track depot) {
              <mat-option [value]="depot.id">{{depot.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 12%">
          <mat-label>User</mat-label>
          <mat-select [(value)]="selectedUserId" (selectionChange)="userChange($event.value)">
            <mat-option value="">None</mat-option>
            @if (!userList || userList.length != 1) {
              <mat-option value="00000000-0000-0000-0000-000000000000">All</mat-option>
            }
            @for (user of userList; track user) {
              <mat-option [value]="user.id">{{user.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (data?.length) {
        <div class="col-sm-12 results">
          <div class="table-responsive">
            <table id="report" class='table table-sm card-table table-wrap' aria-labelledby="tableLabel">
              <thead>
                <tr>
                  <th class="default sortableColumn" (click)="sortData('ActionDate')">
                    <a class="sort text-dark" data-sort>Action Date</a>
                  </th>
                  <th class="default sortableColumn" (click)="sortData('Contract')">
                    <a class="sort text-dark" data-sort>Contract</a>
                  </th>
                  <th class="asset sortableColumn" (click)="sortData('Container')">
                    <a class="sort text-dark" data-sort>Container</a>
                  </th>
                  <th class="description3" title="The depot">Depot</th>
                  <th class="location" title="The location">Location</th>
                  <th class="default" title="The user">User</th>
                  <th class="count" title="The number of days on site when actioned">Days On Site</th>
                  <th class="description2" title="The subsequent action on PIN">Subsequent Action (PIN)</th>
                  <th class="description" title="Variance from expected actions">Variance</th>
                  <th class="description2" title="The latest action on Elemos">Latest Action (Elemos)</th>
                </tr>
              </thead>
              <tbody class="here">
                @for (container of data; track container; let ind = $index) {
                  <ng-container class="py-2">
                    <tr>
                      <td class="default">
                        <span>
                          {{ container.actionDateDisplay }}
                        </span>
                      </td>
                      <td class="default">
                        <span>
                          {{ container.externalReference }}
                        </span>
                      </td>
                      <td class="asset">
                        <span>
                          {{ container.assetId }}
                        </span>
                      </td>
                      <td class="description3" title="{{container.depotName}}">
                        <span>
                          {{ container.depotName }}
                        </span>
                      </td>
                      <td class="location" title="{{container.locationName}}">
                        <span>
                          {{ container.locationName }}
                        </span>
                      </td>
                      <td class="default" title="{{container.userNameDisplay}}">
                        <span>
                          {{ container.userNameDisplay }}
                        </span>
                      </td>
                      <td class="count">
                        <span>
                          {{ container.daysOnSite }}
                        </span>
                      </td>
                      <td class="description2" title="{{container.nextActionDisplay}}">
                        <span>
                          {{ container.nextActionDisplay }}
                        </span>
                      </td>
                      <td class="description" title="{{container.varianceDescription}}">
                        <span>
                          {{ container.varianceDescription }}
                        </span>
                      </td>
                      <td class="description2" title="{{container.latestActionDisplay}}">
                        <span>
                          {{ container.latestActionDisplay }}
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  </ng-container>
                }
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="13" class="py-0">
                    <table style="width: 100%;">
                      <tr>
                        <th class="text-left">
                          <span class="footer">Total Actions: {{ data?.length }}</span>
                        </th>
                      </tr>
                    </table>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      }
    </div>
  </div>
</div>